/* eslint-disable */
export default {
  forward: '轉接',
  cancel: '取消',
  customNumber: '自訂號碼',
} as const;

// @key: @#@"forward"@#@ @source: @#@"Forward"@#@
// @key: @#@"cancel"@#@ @source: @#@"Cancel"@#@
// @key: @#@"customNumber"@#@ @source: @#@"Custom number"@#@
